/**
 * Created by PJPERF on 05.04.2017.
 */
import React from 'react'
import Select from 'react-select';
import Field from './field_class';

class SelectField extends Field{
    getWrapClassName() {
        return `select field_wrap ${this.getNamePostfix()} ${(this.props.className) ? this.props.className : ""}`;
    }
    onChange(val) {
        if (val) {
            this.props.onChange({name: this.props.name, value: val.value});
        } else {
            this.props.onChange({name: this.props.name, value: ''});
        }
    }
    showInput() {
        let value = (this.props.value !== '') ? this.props.value : '';
        let options = (!Array.isArray(this.props.options)) ? [] : this.props.options;
        let clearable = (this.props.allowEmpty) ? true : false;
        let select_id = {'id':this.props.name};
        let name_postfix = (this.props.postfix) ? this.props.name + '_' + this.props.postfix : this.props.name + '_edit';
        return (
            <Select name={name_postfix}
                clearable={clearable}
                inputProps={select_id}
                value={value}
                options={options}
                onChange={this.onChange.bind(this)}
                disabled={this.isDisabled()}/>
        );
    }
}

export default SelectField;